import React from 'react';
import Grid from "@mui/material/Grid";
import {CircularProgress} from "@mui/material";

const Loading = (props) => {
    return (
        <Grid
            container
            direction={props.direction ?? "row"}
            justifyContent={props.justify ?? "center"}
            alignItems={props.alignItems ?? "center"}
            {...props.containerProps ?? {}}
        >
            <Grid item>
                <CircularProgress {...props}/>
            </Grid>
            {props.children}
        </Grid>
    );
};

export default Loading;
